import { ArrowRight } from 'lucide-react';

export function ActionLink({ label, desc, onClick }) {
  return (
    <button onClick={onClick} className="w-full flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 text-left group transition-colors">
      <div>
        <p className="text-sm font-medium text-slate-800">{label}</p>
        <p className="text-[10px] text-slate-400">{desc}</p>
      </div>
      <ArrowRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-indigo-500 transition-colors flex-shrink-0" />
    </button>
  );
}
